<template>
  <div id="confirm-box" v-if="dialog">
    <div class="overlay" @click="dialog = false"></div>
    <div class="layer shadow">
      <div class="message">
        {{ message }}
      </div>
      <!-- <v-alert :value="true" type="warning">
        
      </v-alert> -->
      <div class="confirm-button">
        <v-btn color="success" @click="confirmDialog">{{
          $t("confirm_box.okay")
        }}</v-btn>
      </div>
      <div class="cancel-button">
        <v-btn class="cancel-btn" @click="cancelDialog">{{
          $t("confirm_box.cancel")
        }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      content: null,
      message: "",
      onKeyUp: e => {
        if (e.key === "Enter") {
          this.confirmDialog();
        }
      }
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },
  methods: {
    openDialog(message, content) {
      this.message = message;
      this.content = content;
      this.dialog = true;
    },
    confirmDialog() {
      if (this.content) {
        this.$emit("confirmDialog", this.content);
      }
      this.content = null;
      this.dialog = false;
    },
    cancelDialog() {
      this.dialog = false;
    }
  }
};
</script>

<style>
.layer {
  width: 600px;
  height: 150px;
  left: 50%;
  top: 50px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background: rgba(251, 138, 0, 0.904);
  position: fixed;
  z-index: 1001;
}
.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(17, 17, 17, 0.863);
  opacity: 0.8;
  display: block;
  z-index: 1001;
}
.confirm-button {
  position: absolute;
  left: 0;
  bottom: 0;
}
.cancel-button {
  position: absolute;
  right: 0;
  bottom: 0;
}
.cancel-btn {
  background: #e53935 !important;
  color: white !important;
}
.message {
  width: 100%;
  position: relative;
  top: 20px;
  text-align: center;
  font-size: 20px;
  font-weight: 800;
  color: #673ab7;
}
</style>
